module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Confirm associate","message":"Are you sure you want to associate the user with the organization <b>{item1} (CVR: {item2})</b>?"},"da":{"title":"Bekræft tilknytning","message":"Er du sikker på, at du vil tilknytte brugeren til organisationen <b>{item1} (CVR: {item2})</b>?"}}')
  delete Component.options._Ctor
}
